import axios from './../plugins/private-api-axios'

export const eventAlertLevelsSettingsService = {
    urlPrefix: '/eventAlertLevels',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async editEventAlertLevelsSettings (id, alertLevels) {
        try {
            return await axios.put(`${this.urlPrefix}`, {
                id: id,
                alertLevels: alertLevels
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async editEventAlertLevelsVehicleFleetSettings (id, alertLevels) {
        try {
            return await axios.put(`${this.urlPrefix}/vehicleFleet`, {
                id: id,
                alertLevels: alertLevels
            }, this.config)
        } catch (e) {
            throw e
        }
    },
    async getEventAlertLevelsSettings (vehicleId) {
        try {
            return await axios.get(`${this.urlPrefix}/${vehicleId}?vehicleId=${vehicleId}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getEventAlertLevelsVehicleFleetSettings (vehicleFleetId) {
        try {
            return await axios.get(`${this.urlPrefix}/vehicleFleet/${vehicleFleetId}?vehicleFleetId=${vehicleFleetId}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateEventAlertLevelsSettingsService = (accessToken) => {
    eventAlertLevelsSettingsService.config.headers.Authorization = accessToken
}

export default eventAlertLevelsSettingsService
